<template>
    <div class="user-data">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="p-title Raleway p-black"><b>User data request</b></p>
                                <p class="Raleway min-med p-dgrey">You only need to fill in your details below and then click Continue.
                                    The information below needs your new electricity trading company in order for a change to be carried out.</p>
                            </div>
                        </div>
                    </div>
                    <!-- this code may be overwrite on page DataConfimation on comment -->

                    <div class="images__blck">
                        <div class="row justify-content-between">
                            <div class="col-md-6">
                                <div class="img__item">
                                    <img src="/img/candel.svg" alt="">
                                    <p class="min">A switch never causes any power failure</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="img__item">
                                    <img src="/img/cash2.svg" alt="">
                                    <p class="min">In average our customers save 2000 Kr/year</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detail">
                       <div class="row">
                           <div class="col-md-6 brdr-right">
                               <div class="user-form">


                                   <div class="detail-form form">
                                       <div class="titles">
                                           <p class="Raleway max-max"><b>Customer details</b></p>
                                       </div>
                                       <div class="form__blck">
                                           <div class="info__blck">
                                               <img src="/img/icon/waving-hand.svg" alt="">
                                               <p class="min">We will never call as irretating salepeople</p>
                                           </div>
                                           <div class="form-group">
                                               <label @click="forLabelClick($event)">Phone number</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"

                                                      title="Phone number">
                                           </div>
                                           <div class="form-group disabled active" :class="{ 'disabled' : editInput }">

                                               <label @click="forLabelClick($event)">Phone number</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      v-model="editable"
                                                      :disabled="editInput"
                                                      value="editable"
                                                      title="Phone number">

                                               <span class="edit" @click="editInput = !editInput">Edit</span>
                                           </div>
                                           <div class="form-group btns ">
                                               <button class="btn btn-green btn-full">continue</button>
                                           </div>
                                           <div class="result-phone">
                                               <p class="max-max p-center p-bold">Hi Peter, är de du som är Peter?</p>
                                               <div class="btns">
                                                   <div class="row">
                                                       <div class="col-6">
                                                           <button class="btn btn-green btn-full">Yes</button>
                                                       </div>
                                                       <div class="col-6">
                                                           <button class="btn btn-gray btn-full">No</button>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                           <div class="result-phone">
                                               <p class="max-max p-center p-bold">Please fill in your personnummer</p>
                                           </div>
                                           <div class="form-group disabled">
                                               <label @click="forLabelClick($event)">Personnummer</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      disabled
                                                      title="Phone number">
                                           </div>
                                           <div class="form-group btns ">
                                               <button class="btn btn-green btn-full">continue</button>
                                           </div>
                                           <!--disabled-->

                                           <!--end disabled-->
                                       </div>
                                   </div>


                                   <div class="info-form form">
                                       <div class="titles">
                                           <p class="Raleway max-max"><b>Facility information</b></p>
                                       </div>
                                       <div class="form__blck">
                                           <!--dirty-->
                                           <div class="form-group dirty active" :class="{'active': checkClass(streetAddres) }">
                                               <label @click="forLabelClick($event)">Street address</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      v-model="streetAddres"
                                                      title="streetAddres">
                                           </div>
                                           <!--end dirty-->
                                           <!--error-->
                                           <div class="form-group error">
                                               <label @click="forLabelClick($event)">Post code</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      title="Phone number">
                                               <span class="error-text">Please enter your address</span>
                                           </div>
                                           <!--end error-->
                                           <div class="form-group">
                                               <label @click="forLabelClick($event)">Post office</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      title="Phone number">
                                           </div>
                                           <div class="form-group label-group">

                                               <label @click="forLabelClick($event)">Area ID</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      title="Phone number">

                                               <span class="labeled"  :class="{'active': active1}" @click="active1 = !active1"></span>
                                               <div class="mini-popup" v-if="active1"  :class="{'active': active1}"  @click="active1 = !active1">
                                                   <div class="m_popup__blck">
                                                       <div class="title">
                                                           <p class="Raleway min p-dgrey"><b>Area ID</b></p>
                                                       </div>
                                                       <div class="content">
                                                           <p class="min-min p-dgrey">If the consumer chooses to break the contract entered in early, the Lighthouse has the right to charge a ransom fee. This exercise fee is calculated at 20% of the agreed energy price for estimated consumption during the remaining part of the contract period plus an administrative fee of SEK 450 incl. VAT.</p>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>

                                       </div>
                                   </div>
                                   <div class="address-form form">
                                       <div class="titles">
                                           <p class="Raleway max-max"><b>Fakturaadress</b></p>
                                       </div>
                                       <div class="form__blck">

                                           <div class="form-group checkbox-item">
                                               <label>Same as plant address:</label>
                                               <span class="checkbox-blue">
                                                   <input type="checkbox" title="title" v-model="checkbox">
                                                   <span class="box"></span>
                                               </span>

                                           </div>
                                           <transition name="fade">
                                           <!--dirty-->
                                           <div class="form-group dirty" v-if="checkbox">
                                               <label @click="forLabelClick($event)">Street address</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      v-model="streetAddres"
                                                      title="streetAddres">
                                           </div>
                                           <!--end dirty-->
                                           </transition>
                                           <transition name="fade">
                                           <!--error-->
                                           <div class="form-group error" v-if="checkbox">
                                               <label @click="forLabelClick($event)">Post code</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      title="Phone number">
                                               <span class="error-text">Please enter your address</span>
                                           </div>
                                           <!--end error-->
                                           </transition>
                                           <transition name="fade">
                                           <div class="form-group" v-if="checkbox">
                                               <label @click="forLabelClick($event)">Post office</label>
                                               <input type="text" class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      title="Phone number">
                                           </div>
                                           </transition>
                                       </div>
                                   </div>
                                   <div class="info-form form">
                                       <div class="titles">
                                           <p class="Raleway max-max"><b>Agreements Home</b></p>
                                       </div>
                                       <div class="form__blck">
                                           <div class="form-group date_picker error" :class="{'active': dateOpen}">
                                               <label
                                                       @click="formDateLabelOpen($event)"
                                                       for="">Choose date</label>

                                           <datepicker
                                                   :input-class="'form-control'"
                                                   @opened="formDateOpen($event)"
                                                   @closed="formDateClose($event)"
                                                   @click="ClickEvent($event)"

                                           ></datepicker>
                                               <span class="error-text">Please enter your date</span>
                                           </div>
                                           <div class="form-group date_picker" :class="{'active': dateOpen}">
                                               <label
                                                       @click="formDateLabelOpen($event)"
                                                       for="">Choose date</label>

                                               <datepicker
                                                       :input-class="'form-control'"
                                                       @opened="formDateOpen($event)"
                                                       @closed="formDateClose($event)"
                                                       @click="ClickEvent($event)"

                                               ></datepicker>

                                           </div>
                                           <div class="form-group terms error"  v-if="!isMobile">
                                               <!--if error add class "check-error"-->
                                               <span class="checkbox">
                                                   <input type="checkbox" title="title">
                                                   <span class="box"></span>
                                               </span>
                                               <label class="min p-gray2">I teste test test test test test agree TecknaEl.se <a href="#">Terms</a> and <a href="#">Privacy</a></label>
                                               <!--end error-->

                                           </div>
                                           <div class="form-group check-group terms error"  v-if="!isMobile">
                                               <!--if error add class "check-error"-->
                                               <span class="checkbox check-error">
                                                   <input type="checkbox" title="title">
                                                   <span class="box"></span>
                                               </span>
                                               <label class="min p-gray2">I teste test test test test test agree TecknaEl.se <a href="#">Terms</a> and <a href="#">Privacy</a></label>
                                               <!--end error-->
                                               <span class="error-text">Please enter your date</span>
                                           </div>
                                       </div>
                                   </div>

                               </div>
                           </div>
                           <div class="col-md-6">
                               <div class="contract-info">
                                   <div class="titles">
                                       <p class="Raleway max-max"><b>Contract information</b></p>
                                   </div>
                                   <div class="contract_logo">
                                       <img src="/img/telinet.svg" alt="">
                                   </div>
                                   <div class="contract__data">
                                       <div class="name">
                                           <p class="max-max p-blue">Telinet Energi</p>
                                       </div>
                                       <div class="phone">
                                           <p class="min-min"><b>Org. Number:</b> 556766-5053</p>
                                       </div>
                                       <div class="description">
                                           <p class="p-light min">Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi</p>
                                           <a href="#" class="min">Read more</a>
                                       </div>
                                       <div class="bindings">
                                           <div class="collapsible__el " :class="{'active': collapses1}" >
                                               <div class="title_el" @click="collapses1 = !collapses1">
                                                   <p class="min"><b>Binding time</b>
                                                       <span class="quest__in_icon">
                                                    </span>
                                                   </p>
                                                   <p class="min p-blue">9 months</p>
                                               </div>
                                               <transition name="fade">
                                                   <div class="content" v-if="collapses1">
                                                       <p class="min-min">If the consumer chooses to break the contract entered in early, the Lighthouse has the right to charge a ransom fee. This exercise fee is calculated at 20% of the agreed energy price for estimated consumption during the remaining part of the contract period plus an administrative fee of SEK 450 incl. VAT. The remaining contract period is counted in whole months. The monthly consumption is calculated as one twelfth of the annual consumption stated by the electricity grid owner last. At the customer's definitive relocation, where no new plant is put into use, the agreement can be terminated prematurely without a ransom charge being charged.</p>
                                                   </div>
                                               </transition>

                                           </div>

                                       </div>
                                       <div class="file__list">
                                           <div class="file__item">
                                               <img src="/img/icon/pdf.svg" alt="">
                                               <a href="#" class="min">Contract terms Telinet Energi</a>
                                           </div>
                                           <div class="file__item">
                                               <img src="/img/icon/pdf.svg" alt="">
                                               <a href="#" class="min">Contract terms Telinet Energi</a>
                                           </div>
                                           <div class="file__item">
                                               <img src="/img/icon/pdf.svg" alt="">
                                               <a href="#" class="min">Contract terms Telinet Energi</a>
                                           </div>
                                       </div>
                                       <div class="price__info">
                                           <div class="collapsible__el"  :class="{'active': collapses2}" >
                                               <div class="title_el"  @click="collapses2 = !collapses2">
                                                   <p class="p-white Raleway p-bold">Fixed Price</p>
                                                   <p class="min-min p-white">Show details <img src="/img/icon/arrow-down-white.svg" alt=""></p>
                                               </div>
                                               <transition name="fade">
                                               <div class="content"  v-if="collapses2">
                                                   <div class="row">
                                                       <div class="col-8">
                                                           <div class="title">
                                                               <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                               <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                           </div>
                                                       </div>
                                                       <div class="col-4">
                                                           <div class="cost">
                                                               <p class="p-dgrey med-max">45.90</p>
                                                           </div>
                                                       </div>
                                                   </div>
                                                   <div class="row">
                                                       <div class="col-8">
                                                           <div class="title">
                                                               <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                               <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                           </div>
                                                       </div>
                                                       <div class="col-4">
                                                           <div class="cost">
                                                               <p class="p-dgrey med-max">45.90</p>
                                                           </div>
                                                       </div>
                                                   </div>
                                                   <div class="row">
                                                       <div class="col-8">
                                                           <div class="title">
                                                               <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                               <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                           </div>
                                                       </div>
                                                       <div class="col-4">
                                                           <div class="cost">
                                                               <p class="p-dgrey med-max">45.90</p>
                                                           </div>
                                                       </div>
                                                   </div>
                                                   <div class="row">
                                                       <div class="col-8">
                                                           <div class="title">
                                                               <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                               <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                           </div>
                                                       </div>
                                                       <div class="col-4">
                                                           <div class="cost">
                                                               <p class="p-dgrey med-max">45.90</p>
                                                           </div>
                                                       </div>
                                                   </div>

                                               </div>
                                               </transition>
                                               <div class="less_price">
                                                   <div class="row">
                                                       <div class="col-6 col-md-6 col-lg-7">
                                                           <div class="total">
                                                               <p class="p-blue">Total:</p>
                                                           </div>
                                                       </div>
                                                       <div class="col-6 col-md-6 col-lg-5">
                                                           <div class="total-cost">
                                                               <p class="p-yellow">45.90</p>
                                                               <p class="min">öre / kWh incl</p>
                                                           </div>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="form-group terms" v-if="isMobile">
                                           <!--if error add class "check-error"-->
                                           <span class="checkbox">
                                                   <input type="checkbox" title="title">
                                                   <span class="box"></span>
                                               </span>
                                           <label class="min p-gray2">I agree teste test test test test test TecknaEl.se <a href="#">Terms</a> and <a href="#">Privacy</a></label>
                                           <!--end error-->
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                        <div class="row justify-content-center done-btn">
                            <div class="col-md-4">

                                <button class="btn btn-green btn-full btn-green-disabled">Done</button>
                            </div>
                        </div>
                    </div>
                    <!-- End overwrite section -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    export default {
        name: "UserData",
        data: function(){
          return {
              active1: false,
              collapses1: false,
              collapses2: false,
              streetAddres: "",
              checkbox: false,
              editable: "Edit",
              windowWidth: 0,
              editInput: true,
              dateOpen: false
          }
        },
        methods: {
            formControlFocus($event){
                $event.target.parentElement.classList.add('active');

            },
            formControlBlur($event){
                if($event.target.value === ""){
                    $event.target.parentElement.classList.remove('active');

                }

            },


            forLabelClick($event){

                if(!$event.target.parentElement.classList.contains("disabled")){
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();
                }

            },
            formDateLabelOpen($event){
                $event.target.parentElement.children[1].children[0].children[0].click();
                console.log($event.target.parentElement.children[1].children[0].children[0]);
                this.dateOpen = !this.dateOpen;
            },
            checkClass(enter) {
                if (enter === "") {
                    console.log(enter);
                    return false
                } else {
                    return true
                }
            },


            handleResize() {
                this.windowWidth = window.innerWidth;
            },


        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            isMobile: function () {
                if(this.windowWidth > 767){
                    return false;
                } else {
                    return true;
                }

            }
        },
        components: {
            Datepicker
        }
    }
</script>